/* global axios */
import ApiClient from './ApiClient';

class TalkviaCreditDashboardAPI extends ApiClient {
  constructor() {
    super('talkvia_credit_dashboard', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  analyze(params) {
    return axios.post(`${this.url}/analyze`, params);
  }

  records(params) {
    return axios.get(`${this.url}/records`, { params });
  }

  revealCpf(params) {
    return axios.post(`${this.url}/reveal_cpf`, params);
  }

  deleteSimulationResult(resultId) {
    return axios.delete(`${this.url}/simulation_results/${resultId}`);
  }

  exportNoOffers(params = {}) {
    return axios.get(`${this.url}/no_offer_export`, {
      params,
      responseType: 'blob',
    });
  }

  exportJourney(params = {}) {
    return axios.get(`${this.url}/journey_export`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new TalkviaCreditDashboardAPI();
